// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1R00x","load-ltr":"U6rjR","loadLtr":"U6rjR","load-rtl":"WV5Ld","loadRtl":"WV5Ld"};